import { useState, useEffect, useCallback } from 'react';
import { getHospitalBatches } from '../../../Http/Index';

export interface BatchSummary {
  jobId: string;
  insurance: string;
  source: string;
  createdAt: string;
  total: number;
  formatted: number;
  matched: number;
  doubtful: number;
  new_hospital: number;
  approved: number;
  rejected: number;
  pending: number;
}

export const useBatchList = () => {
  const [batches, setBatches] = useState<BatchSummary[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (p = page) => {
    setLoading(true);
    try {
      const res = await getHospitalBatches(p, 10);
      setBatches(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error('Failed to load batches', err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => { load(); }, [load]);

  return { batches, page, setPage, totalPages, loading, reload: load };
};
